import React, { useEffect, useState } from 'react';
import './SupprimerVente.css';
import api from '../../api';

function SupprimerVente() {
  const [ventes, setVentes] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchVentes = async () => {
    try {
      const res = await api.get('/sales', {
        params: { page, limit: 10 }
      });

      setVentes(res.data.sales || []);
      setTotalPages(res.data.totalPages || 1);
      setLoading(false);
    } catch (err) {
      console.error('Erreur de récupération des ventes:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVentes();
  }, [page]);

  const toggleSelection = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((el) => el !== id) : [...prev, id]
    );
  };

  const handleDelete = async () => {
    if (selectedIds.length === 0) return alert('Aucune vente sélectionnée');

    if (!window.confirm('Confirmer la suppression des ventes sélectionnées ?')) return;

    try {
      const res = await api.delete('/sales', {
        data: { ids: selectedIds }
      });

      alert(res.data.message || 'Ventes supprimées avec succès');
      setSelectedIds([]);
      fetchVentes();
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      alert('Erreur lors de la suppression');
    }
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setPage(i)}
          disabled={i === page}
          className={`pagination-number ${i === page ? 'active' : ''}`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination-container">
        <button onClick={() => setPage(1)} disabled={page === 1} className="pagination-btn">&#171;</button>
        <button onClick={() => setPage(page - 1)} disabled={page === 1} className="pagination-btn">&#8249;</button>
        {pages}
        <button onClick={() => setPage(page + 1)} disabled={page === totalPages} className="pagination-btn">&#8250;</button>
        <button onClick={() => setPage(totalPages)} disabled={page === totalPages} className="pagination-btn">&#187;</button>
      </div>
    );
  };

  return (
    <div className="supprimer-vente-container">
      <h2>Supprimer des Ventes</h2>
      {loading ? (
        <p>Chargement des ventes...</p>
      ) : (
        <>
          <ul className="vente-liste">
            {ventes.map((vente) => (
              <li key={vente._id} className="vente-item">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(vente._id)}
                    onChange={() => toggleSelection(vente._id)}
                  />
                  <span className="vente-titre">{vente.title}</span>
                  <span className="vente-cat">{vente.category}</span>
                  <span className='vente-reference'>{vente.details.reference}</span>
                  <span className="vente-prix">{vente.details?.price} XOF</span>
                </label>
              </li>
            ))}
          </ul>
          {renderPagination()}
          <button
            className="btn-supprimer"
            onClick={handleDelete}
            disabled={selectedIds.length === 0}
          >
            Supprimer les ventes sélectionnées
          </button>
        </>
      )}
    </div>
  );
}

export default SupprimerVente;
